<template>
  <section class="text-and-image">
    <div class="container" :style="'direction: ' + imgPosition">
      <div class="row">
        <div class="col-xl-6 col-lg-7" data-aos="fade-right">
          <img :src="imagePath" class="img-fluid" alt="" />
        </div>
        <div class="col-xl-6 col-lg-5 pt-5 pt-lg-0">
          <h3 data-aos="fade-up">{{ title }}</h3>
          <p data-aos="fade-up">
            <slot />
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    image_left: {
      type: Boolean,
      required: false,
    },
    title: {
      type: String,
      required: true,
    },
    img: {
      type: String,
      required: true,
    },
  },
  computed: {
    imgPosition () {
      return this.image_left ? "ltr" : "rtl";
    },
    imagePath () {
      return "./img/sections/" + this.img;
    },
  },
};
</script>

<style scoped>
h3 {
  font-weight: 400;
  font-size: 34px;
  color: #21413c;
}

.icon-box {
  margin-top: 44px;
}

.icon-box i {
  font-size: 48px;
  float: left;
  color: #1bac91;
}

.icon-box h4 {
  font-size: 22px;
  font-weight: 500;
  margin-left: 60px;
  color: #21413c;
}

.icon-box p {
  font-size: 15px;
  color: #848484;
  margin-left: 60px;
}
</style>
